import { WidgetInstaledDevices } from "components/widgets/WidgetInstaledDevices"
import { WidgetInventory } from "components/widgets/WidgetInventory"
import { WidgetMobileAppUsage } from "components/widgets/WidgetMobileAppUsage"
import { WidgetStatus } from "components/widgets/WidgetStatus"

import { DashboardWidgetSection } from "../components/Dashboard/Dashboard"

export const DevicesSection = () => {
  return (
    <DashboardWidgetSection title="Thermostats">
      <WidgetStatus updateIndex={0} />
      <WidgetInventory updateIndex={0} />
      <WidgetInstaledDevices />
      <WidgetMobileAppUsage />
    </DashboardWidgetSection>
  )
}
